<div class="menu-category-title" [hidden]="!title">
  <h4>
    {{ title }}
  </h4>
</div>
<ng-content></ng-content>
